import Swiper from "swiper/bundle";

export default class ProductDetailsPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initSliders();
  }

  initSliders() {
    const thumbSwiperDOM = this.dom.querySelector(".thumb-slider");
    let thumbSwiper = null;
    if (thumbSwiperDOM != undefined) {
      thumbSwiper = new Swiper(thumbSwiperDOM, {
        direction: "vertical",
        slidesPerView: "auto",
        watchSlidesProgress: true,
      });
    }

    const imgSwiperDOM = this.dom.querySelector(".img-slider");
    let imgPaginationDOM = imgSwiperDOM.querySelector(".swiper-pagination");
    let imgNavigationPrev = imgSwiperDOM.querySelector(".swiper-button-prev");
    let imgNavigationNext = imgSwiperDOM.querySelector(".swiper-button-next");

    let imgSlider = new Swiper(imgSwiperDOM, {
      spaceBetween: 10,
      pagination: {
        el: imgPaginationDOM,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: imgNavigationNext,
        prevEl: imgNavigationPrev,
      },
      thumbs: {
        swiper: thumbSwiper == null ? false : thumbSwiper,
      },
    });
    imgSlider.on("slideChange", () => {
      const thumbnails = thumbSwiperDOM.querySelectorAll(".thumbnail-item");
      thumbSwiper.slideTo(imgSlider.activeIndex);
      for (let thumbnail of thumbnails) {
        thumbnail.classList.remove("on");
        if (imgSlider.activeIndex == thumbnail.getAttribute("data-index")) {
          thumbnail.classList.add("on");
        }
      }
    });

    const thumbnails = thumbSwiperDOM.querySelectorAll(".thumbnail-item");
    for (let thumbnail of thumbnails) {
      thumbnail.addEventListener("click", () => {
        let index = thumbnail.getAttribute("data-index");
        imgSlider.slideTo(index);
        thumbSwiper.slideTo(index);
        thumbnail.classList.add("on");
      });
    }

    const additionalSliderDOMs =
      this.dom.querySelectorAll(".additional-slider");
    for (let sliderDOM of additionalSliderDOMs) {
      let slider = new Swiper(sliderDOM, {
        slidesPerView: 2.5,
        spaceBetween: 10,
        freeMode: true,
        mousewheel: {
          enabled: true,
          sensitivity: 2,
          forceToAxis: true,
        },
      });
    }
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  resize() {}
}
